import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const SoftwareDevelopmentJobsFbd = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Software Development Jobs in Faridabad | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest Software Development Jobs in Faridabad NCR. Explore openings for Java, Python, React, and Full Stack Developers. Apply today on JobsInFaridabadNCR."
        />
        <meta
          name="keywords"
          content="software development jobs in Faridabad, software engineer jobs in Faridabad, software developer jobs Faridabad NCR, IT jobs in Faridabad, full stack developer jobs Faridabad, java developer jobs Faridabad, python developer jobs Faridabad, c++ developer jobs Faridabad, fresher software jobs Faridabad, software company jobs Faridabad"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/softwaredevelopment-jobs-in-faridabad"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Software Development Jobs in Faridabad – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Searching for the latest <strong>Software Development Jobs in Faridabad NCR</strong>? Whether you’re skilled in Java, Python, C++, or web technologies, explore verified job opportunities from top IT companies and startups hiring software developers in Faridabad NCR.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Software Developers in Faridabad
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Accenture</li>
          <li>HCL Technologies</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>TCS</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Software Development Roles in Faridabad NCR
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Engineer Jobs in Faridabad</li>
          <li>Full Stack Developer Jobs in Faridabad</li>
          <li>Backend Developer Jobs in Faridabad</li>
          <li>Frontend Developer Jobs in Faridabad</li>
          <li>Java Developer Jobs in Faridabad</li>
          <li>Python Developer Jobs in Faridabad</li>
          <li>C++ Developer Jobs in Faridabad</li>
          <li>React Developer Jobs in Faridabad</li>
          <li>Angular Developer Jobs in Faridabad</li>
          <li>Software Tester Jobs in Faridabad</li>
        </ul>

        <p className="text-gray-600">
          Begin your software career journey with <strong>jobsindelhincr.in</strong> — your reliable job portal to find verified <strong>Software Development Jobs in Faridabad </strong>. Apply directly without registration and connect with top employers across the region.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default SoftwareDevelopmentJobsFbd;
